export const supportSelector = (state) => state.support;
export const supportTextSelector = (state) => state.support.params.text;
export const supportPageSelector = (state) => state.support.params.page;
